

const Data = {
    user_detail: {
        first_name: "First Name"
    },
    sidebar: {
        servers_category: [
            {
                name: "سرور گرافیکی",
                url: "/servers/datacrunch",
                slug: "datacrunch"
            },
            {
                name: "سرور اختصاصی مجازی VDS",
                url: "/servers/vds",
                slug: "vds"
            },
            {
                name: "سرور مجازی VPS",
                url: "/servers/vps",
                slug: "vps"
            },
            // {
            //     name: "هاست فروشگاهی",
            //     url: "/servers/host-shop",
            //     slug: "host-shop"
            // },
            // {
            //     name: "فروشگاهی وردپرس",
            //     url: "/servers/host-wordpress",
            //     slug: "host-wordpress"
            // },
            // {
            //     name: "فروشگاهی پرستاشاپ",
            //     url: "/servers/host-prestashop",
            //     slug: "host-prestashop"
            // },
            // {
            //     name: "هاست سازمانی",
            //     url: "/servers/host-organization",
            //     slug: "host-organization"
            // },
            // {
            //     name: "هاست GitLab",
            //     url: "/servers/host-gitlab",
            //     slug: "host-gitlab"
            // },
            // {
            //     name: "هاست حسابداری و مالی",
            //     url: "/servers/host-finance",
            //     slug: "host-finance"
            // },
            // {
            //     name: "سرور VoIP",
            //     url: "/servers/voip",
            //     slug: "voip"
            // },
            {
                name: "سرور هتزنر",
                url: "/servers/hetzner",
                slug: "hetzner"
            },
            {
                name: "سرور دیجیتال اوشن",
                url: "/servers/digital-ocean",
                slug: "digital-ocean"
            },
            {
                name: "سرور کونتابا",
                url: "/servers/contabo",
                slug: "contabo"
            },
            // {
            //     name: "سرور میزبانی ایمیل",
            //     url: "/servers/email",
            //     slug: "email"
            // },
        ]
    }
};

export const getCategory = (category) => {
    for (let categories of Data.sidebar.servers_category){
        if (categories.slug === category){
            return {status: true, category: categories}
        }
    }
    return {status: false, category: {}};
}

export default Data;